const Badge = ({ label, style }) => {
  return (
    <span
      className="badge"
      style={{
        backgroundColor: style?.bg,
        color: style?.color,
      }}
    >
      {label}
    </span>
  );
};

export default Badge;